/**
 * Severe Weather Module Routes
 *
 * Route definitions for the Severe Weather module.
 * v2: Severe Weather Forecast (multi-hazard) list view.
 * Future: /severe-weather/tornado, /severe-weather/map
 */

import type { RouteRecordRaw } from 'vue-router'
import ModuleLayout from '@/layouts/ModuleLayout.vue'

const routes: RouteRecordRaw[] = [
    {
        path: '/severe-weather',
        component: ModuleLayout,
        meta: {
            moduleKey: 'severe_weather',
        },
        children: [
            {
                path: '',
                name: 'severe-weather-forecast',
                component: () => import('./views/HailForecastList.vue'),
                meta: {
                    title: 'Severe Weather Forecast',
                },
            },
            {
                path: 'events',
                name: 'severe-weather-events',
                component: () => import('./views/WeatherEventList.vue'),
                meta: {
                    title: 'Weather Events',
                },
            },
            {
                path: 'reports',
                name: 'severe-weather-reports',
                component: () => import('./views/WeatherReportList.vue'),
                meta: {
                    title: 'Weather Reports',
                },
            },
            {
                path: 'reports/:id',
                name: 'severe-weather-report-detail',
                component: () => import('./views/WeatherReportDetail.vue'),
                meta: {
                    title: 'Weather Report',
                },
            },
            {
                path: 'leads',
                name: 'severe-weather-leads',
                component: () => import('./views/WeatherReportLeadsList.vue'),
                meta: {
                    title: 'Weather Report Leads',
                },
            },
        ],
    },
]

export default routes
